import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, TextField, ThemeProvider, createTheme, Tooltip  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import YearSelector from '../YearSelector';
import { formatToYear } from '../../common/StaticExports';
import { useSelector } from 'react-redux';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const HistoryTable = (props?: any) => {
    const { head, addData, handleClick, data, updateList } = props;
    const [newData, setNewData]:any = React.useState({});
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const manageChange = (row: any) => {
    const updatedList = data?.map((d:any) => d?.id == row?.id ? row : d);
    updateList(updatedList);
  }

  const manageDeleteRow = (row: any) => {
    const updatedList = data?.filter((d:any) => d?.id != row?.id);
    updateList(updatedList);
  }

  const manageCreatenew = () => {
    if (newData?.club) {
      const updatedList = [newData, ...data];
      updateList(updatedList);
      setNewData({});
      handleClick();
    }
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    <TableBody>
                      {
                        addData &&
                        <TableRow
                        sx={{ cursor: isAdmin ? 'not-allowed' : 'pointer' }}
                        key={`history-table-row-add-data`}
                        >
                            <TableCell className='fs12'>
                              <TextField variant='standard' sx={{ width: '100%' }} value={newData?.club} 
                              onChange={(e:any) => setNewData({...newData, club: e.target.value})}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <YearSelector
                                value={newData?.yearFrom}
                                manageSelect={(e:any) => setNewData({...newData, yearFrom: parseInt(formatToYear(e))})}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <YearSelector
                                value={newData?.yearTo}
                                manageSelect={(e:any) => setNewData({...newData, yearTo: parseInt(formatToYear(e))})}/>
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {handleClick(); setNewData({});}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={manageCreatenew}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                              <TextField variant='standard' sx={{ width: '100%' }} value={d?.club} 
                              onChange={(e:any) => manageChange({...d, club: e.target.value})} disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <YearSelector
                                value={d?.yearFrom ? d?.yearFrom : null}
                                manageSelect={(e:any) => manageChange({...d, yearFrom: parseInt(formatToYear(e))})} isReadOnly={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <YearSelector
                                value={d?.yearTo ? d?.yearTo : null}
                                manageSelect={(e:any) => manageChange({...d, yearTo: parseInt(formatToYear(e))})} isReadOnly={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {manageDeleteRow(d)}} className={isAdmin ? 'icon mr10 deleteIcon cusrsorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default HistoryTable;